import gql from 'graphql-tag'
import recruterFragment from './RecruterFragment'
export const UPDATED_CONTENT_RECRUTER = gql `
subscription addRecruterContent{
  addRecruterContent{
    ...${recruterFragment}
  }
}
`